import React from 'react'
import * as S from './styled'
import ActionDialog from '../action-dialog'
import { RegularButtonOutline } from '../../atoms'
import { Box } from '@material-ui/core'
import i18n from '../../../assets/i18n'

const ModalSearch = ({ children, isOpen, setIsOpen, disabled = false }) => {
  return (
    <Box component="div">
      <RegularButtonOutline className="button-custom" title={i18n.templateRequestManager.filterProcess} onClick={() => setIsOpen(true)} disabled={disabled} />

      {/* Los botones Limpiar/Buscar los trae el propio formulario que llega en children */}
      <ActionDialog
        open={isOpen}
        title={i18n.modalSearch.title}
        onClose={() => setIsOpen(false)}
        showActions={false}
        disableBackdropClose
        contentStyle={S.contentStyle}
      >
        <S.Body>{children}</S.Body>
      </ActionDialog>
    </Box>
  )
}

export default ModalSearch
